// extracted by mini-css-extract-plugin
module.exports = {"search-input-root":"SearchInput_search-input-root__Fdtvu","select":"SearchInput_select__2XR9o"};